import { render, staticRenderFns } from "./study-executive.vue?vue&type=template&id=5cdec6b8&"
import script from "./study-executive.vue?vue&type=script&lang=js&"
export * from "./study-executive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "study-executive.vue"
export default component.exports